"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _featuredTout = _interopRequireDefault(require("../featured-tout-2"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _excluded = ["items"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Featured tout items */
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** Unique identifier */
    body: _propTypes.node,

    /** Tout body content */
    footer: _propTypes.node,

    /** Tout footer content */
    id: _propTypes.string.isRequired,

    /** Tout img src url */
    image: _propTypes.string,

    /** Title content */
    title: _propTypes.node
  })).isRequired
};
/**
 * Featured Touts 2 component takes list of items and renders a featured tout 2
 * for each. Items are laid out in 1 column that is 100% of its parent width.
 * Root element is [Flex]() and accepts all compatible props. All item props are
 * passed to FeaturedTout2.
 */

var FeaturedTouts2 = function FeaturedTouts2(_ref) {
  var items = _ref.items,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    flexDirection: "column",
    width: 1
  }, props), items.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_featuredTout["default"], _extends({
      key: item.id,
      mb: 4
    }, item));
  }));
};

FeaturedTouts2.propTypes = propTypes;
var _default = FeaturedTouts2;
exports["default"] = _default;